// ᏃꮎꭼᎱꭼꮮ IA™ Brand Gradients - MINIMALISTA SOFISTICADO (Índigo + Cian + Oro)
export const gradients = {
  // Brand Primary Gradients - ÍNDIGO ZOEFEL (#2A1E42)
  brand: "bg-[#2A1E42]",
  primary: "bg-[#2A1E42]",
  secondary: "bg-[#363636]",
  premium: "bg-gradient-to-r from-[#2A1E42] to-[#00C2FF]",
  
  // Hero & Background Gradients - ÍNDIGO con acentos
  hero: "bg-[#2A1E42]",
  darkGradient: "bg-[#363636]",
  lightGradient: "bg-white",
  
  // Card Gradients - BLANCO o GRIS NUBE
  card: "bg-white",
  cardLight: "bg-[#F4F6F8]",
  hover: "hover:bg-[#F4F6F8]",
  
  // Text Gradients - ÍNDIGO para marca
  text: "text-[#2A1E42]",
  textBrand: "text-[#2A1E42]",
  
  // CTA Gradients - CIAN INNOVACIÓN (#00C2FF)
  cta: "bg-[#00C2FF]",
  ctaHover: "hover:bg-[#2A1E42]"
};

// Glow Effects - MINIMALISTA (Índigo + Cian)
export const glowEffects = {
  indigo: "shadow-lg shadow-[#2A1E42]/20",
  cyan: "shadow-lg shadow-[#00C2FF]/30",
  multi: "shadow-xl shadow-[#2A1E42]/20",
  gold: "shadow-lg shadow-[#BC9C71]/20",
  ctaGlow: "shadow-lg shadow-[#00C2FF]/40",
  ctaGlowHover: "shadow-xl shadow-[#2A1E42]/40"
};

// Brand Colors (for inline styles) - MINIMALISTA SOFISTICADO
export const brandColors = {
  primary: "#2A1E42",    // Índigo ZoeFel (Primario)
  secondary: "#363636",  // Carbón Suave (Texto)
  accent: "#00C2FF",     // Cian Innovación (CTAs)
  gold: "#BC9C71"        // Oro Sutil (Premium)
};
